import React, { useEffect, useRef } from "react";
import { useOutletContext } from "react-router-dom";

import VideoViewer from "../../commonComponents/VideoViewer/VideoViewer";
import challengesService from "../../../services/challengesService";

function ChallengeVideo() {
  const [count] = useOutletContext();
  const viewedPdf = useRef(false);

  useEffect(() => {
    if (
      count?.type === "pdf" &&
      count?.categoryId &&
      count?.challengeId &&
      !viewedPdf.current
    ) {
      viewedPdf.current = true;

      challengesService.addChallengeView(
        count.categoryId,
        count.challengeId,
      );
    }
  }, [count?.type, count?.categoryId, count?.challengeId]);

  if (count?.type === "pdf") {
    return (
      <section className="pdfContent">
        <h2>{count?.title}</h2>
        <a
          href={count?.pdf_file}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={count?.cover_image}
            alt={count?.title}
            style={{ maxWidth: "100%", cursor: "pointer" }}
          />
        </a>
      </section>
    );
  } else {
    return (
      <section className="videoContent">
        <VideoViewer
          videoUrl={count?.url}
          handlers="challenges"
          title={count?.title}
          categoryId={count?.categoryId}
          challengeId={count?.challengeId}
        />
      </section>
    );
  }
}

export default ChallengeVideo;